import React from "react";
import { Input } from "antd";

interface ICustomInputProps {
	label?: string;
	placeholder?: string;
	value?: string;
	className?: string;
	disabled?: boolean;
	name?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomInput: React.FC<ICustomInputProps> = ({
	label,
	placeholder,
	value,
	className,
	disabled = false,
	onChange,
	name,
}) => {
	return (
		<div className="flex flex-col ">
			<label>{label}</label>
			<Input
				name={name}
				onChange={onChange}
				className={className}
				placeholder={placeholder}
				value={value}
				disabled={disabled}
			/>
		</div>
	);
};

export default CustomInput;
